import React from "react";
import { IoCog, IoList } from "react-icons/io5";
import { RiShoppingCart2Line } from "react-icons/ri";
import { useSelector } from "react-redux";

import NavMenuItem from "./NavMenuItem";

const NavMenu = () => {
    const userInformation = useSelector(state => state.userLogin?.userInfo || null)
    const menu = userInformation ? userInformation?.menu : [];

    const iconHandler = (to) => {
        switch (to) {
            case '/admin/stores':
                return <RiShoppingCart2Line />
            case '/admin/productlist':
                return <IoList />
            case '/admin/dashboard':
                return <IoCog />
            case '/admin/orders':
                return <RiShoppingCart2Line />
            default:
                return <IoCog />
        }
    }

    return (
        <>
            {
                menu && menu.map((item, index) => (
                    <NavMenuItem 
                        key={index} 
                        text={item.text}
                        to={item.to}
                        icon={iconHandler(item.to)}
                    />
                ))
            }
        </>
    )
}

export default NavMenu;